import { render, staticRenderFns } from "./PCButtonHistoryBack.vue?vue&type=template&id=7bee479f&scoped=true"
import script from "./PCButtonHistoryBack.vue?vue&type=script&lang=js"
export * from "./PCButtonHistoryBack.vue?vue&type=script&lang=js"
import style0 from "./PCButtonHistoryBack.vue?vue&type=style&index=0&id=7bee479f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bee479f",
  null
  
)

export default component.exports